/* Premier Courses — header Courses mega-menu. (rev 2026-07-22b)
   Vanilla JS, no framework. Opens on hover/focus, closes on
   mouseleave / blur-out / Escape. 150ms fade is handled in CSS via the
   [data-open] attribute; this file only toggles state + manages a11y +
   keyboard focus. Also wires the mobile nav drawer toggle.

   Markup contract (see sections/header.liquid):
     [data-pc-megamenu]            wrapper (the "Courses" nav item)
       [data-pc-megamenu-trigger]  the <button> that opens it (aria-expanded)
       [data-pc-megamenu-panel]    the dropdown panel (id referenced by aria-controls)
     [data-pc-nav-toggle]          mobile hamburger (aria-expanded)
     [data-pc-nav]                 the nav element toggled on mobile
*/
(function () {
  'use strict';

  function initMegaMenu(root) {
    var trigger = root.querySelector('[data-pc-megamenu-trigger]');
    var panel = root.querySelector('[data-pc-megamenu-panel]');
    if (!trigger || !panel) return;

    var nav = root.closest('[data-pc-nav]');
    var back = panel.querySelector('[data-pc-megamenu-back]');
    var closeTimer = null;
    var isTouch = false;
    // Hover/focus-open is desktop-only. On the mobile drawer (≤900px, where the
    // menu is an inline accordion) those handlers collide with the tap: focusin
    // opened the panel, then the click toggle immediately closed it — the button
    // just highlighted and nothing expanded. Mobile = click is the sole toggle.
    var desktop = window.matchMedia('(min-width: 901px)');

    function open() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      root.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
      // Mobile drill-down: the drawer swaps to this panel (level-2 view).
      if (!desktop.matches && nav) nav.setAttribute('data-subnav', 'true');
    }

    function close() {
      root.removeAttribute('data-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (nav) nav.removeAttribute('data-subnav');
    }

    // Mobile back row: return to the level-1 list.
    if (back) {
      back.addEventListener('click', function () {
        close();
        trigger.focus();
      });
    }

    // Mobile "+" group toggles inside the panel (inert on desktop via CSS).
    var colToggles = panel.querySelectorAll('[data-pc-col-toggle]');
    for (var ci = 0; ci < colToggles.length; ci++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var col = btn.closest('.pc-megamenu__col');
          if (!col) return;
          var isOpen = col.getAttribute('data-open') === 'true';
          if (isOpen) {
            col.removeAttribute('data-open');
            btn.setAttribute('aria-expanded', 'false');
          } else {
            col.setAttribute('data-open', 'true');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      })(colToggles[ci]);
    }

    // Delay close so the pointer can travel from trigger to panel.
    function deferredClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(close, 120);
    }

    root.addEventListener('mouseenter', function () { if (desktop.matches) open(); });
    root.addEventListener('mouseleave', function () { if (desktop.matches) deferredClose(); });

    // Keyboard / focus (desktop): open when focus is inside, close when it leaves.
    root.addEventListener('focusin', function () { if (desktop.matches) open(); });
    root.addEventListener('focusout', function (e) {
      if (desktop.matches && !root.contains(e.relatedTarget)) close();
    });

    // Click toggle: always on mobile widths; on desktop only for touch input
    // (hover already handles mouse there).
    trigger.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.pointerType === 'pen') {
        isTouch = true;
      }
    });
    trigger.addEventListener('click', function (e) {
      if (!desktop.matches || isTouch) {
        e.preventDefault();
        if (root.getAttribute('data-open') === 'true') {
          close();
        } else {
          open();
        }
      }
    });

    // Escape closes and returns focus to the trigger.
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.getAttribute('data-open') === 'true') {
        close();
        trigger.focus();
      }
    });

    // Click outside closes.
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target) && root.getAttribute('data-open') === 'true') {
        close();
      }
    });
  }

  function initMobileNav() {
    var toggle = document.querySelector('[data-pc-nav-toggle]');
    var nav = document.querySelector('[data-pc-nav]');
    if (!toggle || !nav) return;

    // Scrim element (styled by header.liquid: .pc-nav-scrim) — dims the page
    // behind the open drawer; tapping it closes.
    var scrim = document.querySelector('.pc-nav-scrim');
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'pc-nav-scrim';
      scrim.setAttribute('aria-hidden', 'true');
      document.body.appendChild(scrim);
    }

    function setOpen(open) {
      if (open) {
        nav.setAttribute('data-open', 'true');
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        nav.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', 'false');
        // Reset the drill-down so the drawer reopens at the level-1 list.
        nav.removeAttribute('data-subnav');
        var stale = nav.querySelectorAll('[data-open="true"]');
        for (var si = 0; si < stale.length; si++) stale[si].removeAttribute('data-open');
        var expanded = nav.querySelectorAll('[aria-expanded="true"]');
        for (var ei = 0; ei < expanded.length; ei++) expanded[ei].setAttribute('aria-expanded', 'false');
      }
      scrim.classList.toggle('is-on', open);
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      // Lock the page behind the drawer (CSS: html.pc-nav-open { overflow: hidden }).
      document.documentElement.classList.toggle('pc-nav-open', open);
    }

    toggle.addEventListener('click', function () {
      setOpen(nav.getAttribute('data-open') !== 'true');
    });

    scrim.addEventListener('click', function () { setOpen(false); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.getAttribute('data-open') === 'true') {
        setOpen(false);
        toggle.focus();
      }
    });
  }

  function init() {
    var menus = document.querySelectorAll('[data-pc-megamenu]');
    for (var i = 0; i < menus.length; i++) initMegaMenu(menus[i]);
    initMobileNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when the Shopify theme editor re-renders the header section.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-pc-megamenu]')) {
      init();
    }
  });
})();
